import assetsMap from './assets.json'

export function getAssetUrl(path: string) {
  if (!path.startsWith('/')) {
    path = `/${path}`
  }
  const url = assetsMap[path as keyof typeof assetsMap]
  if (url) {
    return url
  }
  // `import.meta.url` is `undefined` in the UMD bundle, so `new URL(path, import.meta.url)` throws.
  const base = (import.meta.env.VITE_BASE_ASSETS ?? '').replace(/\/+$/, '')
  return `${base}${path}`
}
